import { Instagram, Linkedin } from "lucide-react";

const INSTAGRAM_URL = "https://www.instagram.com/saased.co/";
const LINKEDIN_URL = "https://www.linkedin.com/company/saasedco/";

export function SiteFooter() {
  return (
    <footer aria-label="Site footer" className="border-t border-border/60 bg-background">
      <div className="container-x flex flex-col items-center gap-6 py-14 text-center">
        <p className="max-w-md text-sm text-muted-foreground">
          EMEA's specialist procurement team for Salesforce contracts.
        </p>
        <nav aria-label="Social media" className="flex items-center gap-5">
          <a
            href={INSTAGRAM_URL}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="SaaSed on Instagram"
            title="SaaSed on Instagram"
            className="-m-2 inline-flex items-center justify-center p-2 text-foreground/70 transition hover:text-foreground max-md:-m-3 max-md:min-h-12 max-md:min-w-12 max-md:p-3"
          >
            <Instagram size={22} aria-hidden="true" />
          </a>
          <a
            href={LINKEDIN_URL}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="SaaSed on LinkedIn"
            title="SaaSed on LinkedIn"
            className="-m-2 inline-flex items-center justify-center p-2 text-foreground/70 transition hover:text-foreground max-md:-m-3 max-md:min-h-12 max-md:min-w-12 max-md:p-3"
          >
            <Linkedin size={22} aria-hidden="true" />
          </a>
        </nav>
      </div>
      <div className="border-t border-border/60">
        <div className="container-x flex flex-col items-center gap-1 py-6 text-xs text-muted-foreground">
          <p>Copyright © {new Date().getFullYear()} SaaSed.co</p>
          <p>SaaSed.co Limited</p>
          <p>{"\n"}</p>
        </div>
      </div>
    </footer>
  );
}
